import { createContext } from 'react';
import type { ChatbotContextValue } from './Chatbot.types';

export const ChatbotContext = createContext<ChatbotContextValue | undefined>(undefined);
